import { Box, Button, Typography } from "@mui/material";

import { useNavigate } from "react-router-dom";

const Landing = () => {
    const navigate = useNavigate();

    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="100vh"
            width="100vw"
            overflow="hidden"
            
        >
            <Box
                sx={{
                    width: { xs: "100vw", md: "50vw" },
                }}
            >
                <img
                    style={{ height: "100vh", width: "100%", objectFit: "fill" }}
                    src="/assets/tawheedi_splash3.png"
                    alt="logo"
                />
            </Box>
            <Button

            
                onClick={() => navigate("/home")}
                variant="contained"
                color="secondary"
                sx={{
                    padding: 1,
                    backgroundColor: "#006E94",
                    position: "absolute",
                    bottom: 50,
                    zIndex: 10,
                    width: { xs: "90%", md: "40%" },
                }}
            >
                <Typography variant="h5">ابدأ</Typography>
            </Button>
        </Box>
    );
};

export default Landing;
